import AutomationConfigPanel from "./AutomationConfigPanel";

export default AutomationConfigPanel;
